import { Socket } from 'phoenix';
import Vue from 'vue';
import ChannelKeeper from './channelKeeper';
import VuePhoenixMixin from './mixin';
export * from './obey';
var VuePhoenix = /** @class */ (function () {
    function VuePhoenix(socket, params) {
        this.socket =
            socket instanceof Socket
                ? socket
                : new Socket(socket, {
                    params: params
                });
    }
    VuePhoenix.prototype.install = function (localVue) {
        Vue.prototype.$socket = this.socket;
        Vue.prototype.$channelKeeper = new ChannelKeeper(this.socket);
        Vue.prototype.$vuePhoenix = this;
        localVue.mixin(VuePhoenixMixin);
        this.socket.connect();
    };
    return VuePhoenix;
}());
export default VuePhoenix;
//# sourceMappingURL=index.js.map